import { useEffect } from 'react'

interface TripleWhalePixelOptions {
  disabled?: boolean
  /**
   * If set to `true`, script will be loaded.
   * Defaults to false.
   **/
  hasUserConsent?: boolean
  /**
   * The Triple Whale pixel name.
   **/
  tripleName?: string
}

const apiUrl = 'https://api.config-security.com'
const configUrl = 'https://conf.config-security.com'
const storageKey = 'TriplePixel'
const maxRetries = 5

const generateId = () => {
  return Date.now().toString(36) + '_' + Math.random().toString(36)
}

const sendRequest = (
  url: string,
  retries: number,
  postData?: Record<string, unknown>,
) => {
  const xhr = new XMLHttpRequest()

  if (postData) {
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-Type', 'text/plain')
  } else {
    xhr.open('GET', url, true)
  }

  xhr.send(JSON.stringify(postData || {}))

  let handled = false

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = xhr.responseText

      if (url.includes('/first')) {
        eval(response)
      } else if (!postData) {
        window.configSecurityConfModel = response
      }
    } else if ((xhr.status > 299 || xhr.status < 200) && retries && !handled) {
      handled = true
      sendRequest(url, retries - 1, postData)
    }
  }
}

const trackPageVisit = () => {
  try {
    const visitCount =
      (parseInt(localStorage.getItem(storageKey) || '0') | 0) + 1
    localStorage.setItem(storageKey, String(visitCount))

    const visits = JSON.parse(localStorage.getItem(storageKey + 'U') || '[]')
    visits.push({
      u: location.href,
      r: document.referrer,
      t: Date.now(),
      id: generateId(),
    })
    localStorage.setItem(storageKey + 'U', JSON.stringify(visits))
  } catch {}
}

const initializePixel = (
  tripleName: string,
  pixelData: NonNullable<Window['TriplePixelData']>,
) => {
  if (window.TriplePixelsn) {
    return
  }

  window.TriplePixelsn = 1

  trackPageVisit()

  // Guard against re-initialization
  if (localStorage.getItem('"!nC`') || window.TriplePixel) {
    return
  }

  const triplePixel = function (
    type: string,
    event?: unknown,
    ...args: unknown[]
  ) {
    if (type === 'State') {
      return triplePixel.s
    }

    const id = generateId()
    triplePixel._q = triplePixel._q || []
    triplePixel._q.push([id, type, event, ...args])
    return id
  }

  triplePixel.s = 'Installed'
  triplePixel._q = [] as unknown[][]
  triplePixel.ch = ''

  window.TriplePixel = triplePixel
  window.configSecurityConfModel = 1

  // Load configuration model
  sendRequest(`${configUrl}/model`, maxRetries)

  // Send profile event
  const profileId = generateId()
  const screen = window.screen

  localStorage.setItem('di_pmt_wt', profileId)

  const profileData = {
    id: profileId,
    action: 'profile',
    avatar: localStorage.getItem('auth-security_rand_salt_'),
    time: screen.width + ':' + screen.height,
    host: pixelData.TripleName,
    plat: pixelData.plat,
    url: window.location.href.slice(0, 500),
    ref: document.referrer,
    ver: pixelData.ver,
  }

  sendRequest(`${apiUrl}/event`, maxRetries, profileData)
  sendRequest(`${apiUrl}/first?host=${tripleName}&plat=SHOPIFY`, maxRetries)
}

/**
 * Triple Whale pixel loading script hook.
 */
export const useTripleWhalePixel = (options?: TripleWhalePixelOptions) => {
  useEffect(() => {
    const disabled = Boolean(options?.disabled)
    const hasUserConsent = Boolean(options?.hasUserConsent)
    const tripleName = options?.tripleName

    if (disabled || !hasUserConsent || !tripleName) {
      return
    }

    window.TriplePixelData = {
      TripleName: tripleName,
      ver: '2.17',
      plat: 'SHOPIFY',
      isHeadless: true,
    }

    initializePixel(tripleName, window.TriplePixelData)
  }, [options])
}
